import React, { useState } from "react";
import { TabButton } from "../../common/APICommon";

import { CreditNotes } from "./CreditNotes"
import { PaymentsReceived } from "./PaymentsReceived"
import { SalesOrder } from "./SalesOrder"
import { DeliveryOrder } from "./DeliveryOrder"
import { SalesInvoice } from "./SalesInvoice"
import Journals from "../Accounts/Journals"
import NoAccess from "../NoAccess";
// MUI Icons
import AddCardIcon from '@mui/icons-material/AddCard';
import { DeliveryReturn } from "./DeliveryReturn";

export default function Receivables() {








// #region Tabs
  const [activeTab, setActiveTab] = useState("SalesOrders")

  const tabs = [
    {
      label:"Sales Orders",
      isActive: activeTab === "SalesOrders",
      onClick: () => setActiveTab("SalesOrders")
    },
    {
      label:"Delivery Order",
      isActive: activeTab === "DeliveryOrder",
      onClick: () => setActiveTab("DeliveryOrder")
    },
    {
      label:"Delivery Return",
      isActive: activeTab === "DeliveryReturn",
      onClick: () => setActiveTab("DeliveryReturn")
    },
    {
      label:"Sales Invoices",
      isActive: activeTab === "SalesInvoices",
      onClick: () => setActiveTab("SalesInvoices")
    },
    {
      label:"Credit Notes",
      isActive: activeTab === "CreditNotes",
      onClick: () => setActiveTab("CreditNotes")
    },
    {
      label:"Payments Received",
      isActive: activeTab === "PaymentsReceived",
      onClick: () => setActiveTab("PaymentsReceived")
    },
    {
      label:"AR Transactions",
      isActive: activeTab === "ARTransactions",
      onClick: () => setActiveTab("ARTransactions")
    },
  ]
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasReceivables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <AddCardIcon fontSize="large" className="text-theme-color" />
              Receivables
            </h2>
            <p className="text-gray-500 mt-1">Goods or services sold on credit.</p>
          </div>
        </div>

        {tabs.map((tab, index) => {
          return (
            <TabButton
              key={index}
              label={tab.label}
              isActive={tab.isActive}
              onClick={tab.onClick}
            />
          )
        })}

        {activeTab === "SalesOrders" &&
          <SalesOrder active={activeTab === "SalesOrders"}/>
        }
        {activeTab === "DeliveryOrder" &&
          <DeliveryOrder active={activeTab === "DeliveryOrder"}/>
        }
        {activeTab === "DeliveryReturn" &&
          <DeliveryReturn active={activeTab === "DeliveryReturn"}/>
        }
        {activeTab === "SalesInvoices" &&
          <SalesInvoice active={activeTab === "SalesInvoices"}/>
        }
        {activeTab === "PaymentsReceived" &&
          <PaymentsReceived active={activeTab === "PaymentsReceived"}/>
        }
        {activeTab === "CreditNotes" &&
          <CreditNotes active={activeTab === "CreditNotes"}/>
        }
        {activeTab === "ARTransactions" &&
          <Journals type={"AR"}/>
        }
      </div>
    </>
  );
}







